import { atom } from '@zedux/react'

const mailSubTitleAtom = atom("mailSubTitleAtom", "")

export default mailSubTitleAtom
